export default "__VITE_ASSET__4f6759d2__"